import React from "react";
import { ArrowDown, ArrowUp } from "lucide-react";

const normalizeOrder = (question, value) => {
    const optionIds = (question.reponsesPossibles || []).map((option) => String(option.id));
    const ordered = Array.isArray(value) ? value.map(String).filter((id) => optionIds.includes(id)) : [];
    const missing = optionIds.filter((id) => !ordered.includes(id));
    return [...ordered, ...missing];
};

export default function QuestionClassement({ question, value, onChange, disabled }) {
    const optionsById = new Map((question.reponsesPossibles || []).map((option) => [String(option.id), option]));
    const orderedIds = normalizeOrder(question, value);

    const move = (index, direction) => {
        const nextIndex = index + direction;
        if (nextIndex < 0 || nextIndex >= orderedIds.length) return;

        const next = [...orderedIds];
        [next[index], next[nextIndex]] = [next[nextIndex], next[index]];
        onChange(next);
    };

    return (
        <div className="qr-ranking">
            {orderedIds.map((id, index) => {
                const option = optionsById.get(id);
                if (!option) return null;

                return (
                    <div key={id} className="qr-ranking-row">
                        <span className="qr-ranking-position">{index + 1}</span>
                        <span className="qr-ranking-label">{option.libelle}</span>
                        <div className="qr-ranking-actions">
                            <button
                                type="button"
                                className="qr-icon-btn"
                                onClick={() => move(index, -1)}
                                disabled={disabled || index === 0}
                                title="Monter"
                            >
                                <ArrowUp size={16} />
                            </button>
                            <button
                                type="button"
                                className="qr-icon-btn"
                                onClick={() => move(index, 1)}
                                disabled={disabled || index === orderedIds.length - 1}
                                title="Descendre"
                            >
                                <ArrowDown size={16} />
                            </button>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
